module.exports = __webpack_public_path__ + "0b7b11ec3ee39dab660ca907511e2295.svg";